// @flow
import { connect } from 'react-redux';

import { updateElectronCaptionMode } from '../../../actions';
import { addNotification, clearNotifications, setShowBubbleAboveCCMode } from '../../../actions/cc-mode';
import { setInviteCardOpen, setJoiningStatus } from '../../../actions/conversation';

import ConversationView from './ConversationView';

const mapStateToProps = ({
  ccMode: { showBubbleAboveCCMode },
  scribeConversation: {
    isInConversation,
    isInviteCardOpen,
    joiningStatus,
    muted,
    scribe,
    speakerListened,
    speakers,
    status,
  },
  scribeSession: { captioner, displayable, features, loading, socketConnectionStatus },
  scribeTranscriptUI: { displayShortcuts, fontSize },
}) => ({
  displayable,
  displayShortcuts,
  features,
  fontSize,
  isInConversation,
  isInviteCardOpen,
  joiningStatus,
  muted,
  scribe,
  sessionLoading: loading,
  showBubbleAboveCCMode,
  socketConnectionStatus,
  speakerListened,
  speakers,
  status,
  user: captioner,
});

const mapDispatchToProps = {
  addNotification,
  clearNotifications,
  setInviteCardOpen,
  setJoiningStatus,
  setShowBubbleAboveCCMode,
  updateElectronCaptionMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConversationView);
